"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categories = exports.names = exports.default = void 0;

var _AddressBook = _interopRequireDefault(require("./AddressBook"));

var _Angry = _interopRequireDefault(require("./Angry"));

var _Antenna = _interopRequireDefault(require("./Antenna"));

var _AntennaTimes = _interopRequireDefault(require("./AntennaTimes"));

var _Archive = _interopRequireDefault(require("./Archive"));

var _ArchiveArrowDown = _interopRequireDefault(require("./ArchiveArrowDown"));

var _ArchiveArrowUp = _interopRequireDefault(require("./ArchiveArrowUp"));

var _ArrowBottomLeftCorner = _interopRequireDefault(require("./ArrowBottomLeftCorner"));

var _ArrowBottomRightCorner = _interopRequireDefault(require("./ArrowBottomRightCorner"));

var _ArrowCompress = _interopRequireDefault(require("./ArrowCompress"));

var _ArrowDown = _interopRequireDefault(require("./ArrowDown"));

var _ArrowExpand = _interopRequireDefault(require("./ArrowExpand"));

var _ArrowLeft = _interopRequireDefault(require("./ArrowLeft"));

var _ArrowRight = _interopRequireDefault(require("./ArrowRight"));

var _ArrowTopLeftCorner = _interopRequireDefault(require("./ArrowTopLeftCorner"));

var _ArrowTopRightCorner = _interopRequireDefault(require("./ArrowTopRightCorner"));

var _ArrowUp = _interopRequireDefault(require("./ArrowUp"));

var _Asterisk = _interopRequireDefault(require("./Asterisk"));

var _Ban = _interopRequireDefault(require("./Ban"));

var _BarChart = _interopRequireDefault(require("./BarChart"));

var _BarChartBoard = _interopRequireDefault(require("./BarChartBoard"));

var _BarChartScreen = _interopRequireDefault(require("./BarChartScreen"));

var _Bars = _interopRequireDefault(require("./Bars"));

var _BaselineChart = _interopRequireDefault(require("./BaselineChart"));

var _Bell = _interopRequireDefault(require("./Bell"));

var _BookOpen = _interopRequireDefault(require("./BookOpen"));

var _Brain = _interopRequireDefault(require("./Brain"));

var _Briefcase = _interopRequireDefault(require("./Briefcase"));

var _BriefcasePlus = _interopRequireDefault(require("./BriefcasePlus"));

var _BriefcaseTimes = _interopRequireDefault(require("./BriefcaseTimes"));

var _Building = _interopRequireDefault(require("./Building"));

var _Bullhorn = _interopRequireDefault(require("./Bullhorn"));

var _BullhornTimes = _interopRequireDefault(require("./BullhornTimes"));

var _Calculator = _interopRequireDefault(require("./Calculator"));

var _Calendar = _interopRequireDefault(require("./Calendar"));

var _CalendarCheck = _interopRequireDefault(require("./CalendarCheck"));

var _CalendarExclamation = _interopRequireDefault(require("./CalendarExclamation"));

var _CalendarPlus = _interopRequireDefault(require("./CalendarPlus"));

var _CalendarTimes = _interopRequireDefault(require("./CalendarTimes"));

var _Camera = _interopRequireDefault(require("./Camera"));

var _CaretDown = _interopRequireDefault(require("./CaretDown"));

var _CaretUp = _interopRequireDefault(require("./CaretUp"));

var _CassetteTape = _interopRequireDefault(require("./CassetteTape"));

var _Check = _interopRequireDefault(require("./Check"));

var _CheckCircle = _interopRequireDefault(require("./CheckCircle"));

var _CheckCircleF = _interopRequireDefault(require("./CheckCircleF"));

var _CheckPartialShield = _interopRequireDefault(require("./CheckPartialShield"));

var _CheckShield = _interopRequireDefault(require("./CheckShield"));

var _Checklist = _interopRequireDefault(require("./Checklist"));

var _ChessCastle = _interopRequireDefault(require("./ChessCastle"));

var _ChessKnight = _interopRequireDefault(require("./ChessKnight"));

var _ChevronDoubleLeft = _interopRequireDefault(require("./ChevronDoubleLeft"));

var _ChevronDoubleRight = _interopRequireDefault(require("./ChevronDoubleRight"));

var _ChevronDown = _interopRequireDefault(require("./ChevronDown"));

var _ChevronLeft = _interopRequireDefault(require("./ChevronLeft"));

var _ChevronRight = _interopRequireDefault(require("./ChevronRight"));

var _ChevronUp = _interopRequireDefault(require("./ChevronUp"));

var _Circle = _interopRequireDefault(require("./Circle"));

var _CircleF = _interopRequireDefault(require("./CircleF"));

var _CircleHalfF = _interopRequireDefault(require("./CircleHalfF"));

var _Circuit = _interopRequireDefault(require("./Circuit"));

var _ClearDay = _interopRequireDefault(require("./ClearDay"));

var _ClearNight = _interopRequireDefault(require("./ClearNight"));

var _Clipboard = _interopRequireDefault(require("./Clipboard"));

var _ClipboardCheck = _interopRequireDefault(require("./ClipboardCheck"));

var _ClipboardExclamation = _interopRequireDefault(require("./ClipboardExclamation"));

var _ClipboardTimes = _interopRequireDefault(require("./ClipboardTimes"));

var _Clock = _interopRequireDefault(require("./Clock"));

var _Cloudy = _interopRequireDefault(require("./Cloudy"));

var _CoffeeHot = _interopRequireDefault(require("./CoffeeHot"));

var _Cog = _interopRequireDefault(require("./Cog"));

var _Comment = _interopRequireDefault(require("./Comment"));

var _CommentPlus = _interopRequireDefault(require("./CommentPlus"));

var _Copy = _interopRequireDefault(require("./Copy"));

var _CreditCard = _interopRequireDefault(require("./CreditCard"));

var _CreditCardCheck = _interopRequireDefault(require("./CreditCardCheck"));

var _CreditCardExclamation = _interopRequireDefault(require("./CreditCardExclamation"));

var _CreditCardPlus = _interopRequireDefault(require("./CreditCardPlus"));

var _CreditCardTimes = _interopRequireDefault(require("./CreditCardTimes"));

var _DeliveryCart = _interopRequireDefault(require("./DeliveryCart"));

var _Desktop = _interopRequireDefault(require("./Desktop"));

var _Diamond = _interopRequireDefault(require("./Diamond"));

var _Directions = _interopRequireDefault(require("./Directions"));

var _DoorEnter = _interopRequireDefault(require("./DoorEnter"));

var _DoorExit = _interopRequireDefault(require("./DoorExit"));

var _Download = _interopRequireDefault(require("./Download"));

var _EllipsisH = _interopRequireDefault(require("./EllipsisH"));

var _EllipsisV = _interopRequireDefault(require("./EllipsisV"));

var _Engine = _interopRequireDefault(require("./Engine"));

var _Envelope = _interopRequireDefault(require("./Envelope"));

var _EnvelopeCheck = _interopRequireDefault(require("./EnvelopeCheck"));

var _EnvelopeOpen = _interopRequireDefault(require("./EnvelopeOpen"));

var _EnvelopePlus = _interopRequireDefault(require("./EnvelopePlus"));

var _EnvelopeTimes = _interopRequireDefault(require("./EnvelopeTimes"));

var _Eraser = _interopRequireDefault(require("./Eraser"));

var _Exclamation = _interopRequireDefault(require("./Exclamation"));

var _ExclamationCircle = _interopRequireDefault(require("./ExclamationCircle"));

var _ExclamationCircleF = _interopRequireDefault(require("./ExclamationCircleF"));

var _ExclamationPartialShield = _interopRequireDefault(require("./ExclamationPartialShield"));

var _ExclamationShield = _interopRequireDefault(require("./ExclamationShield"));

var _ExclamationTriangle = _interopRequireDefault(require("./ExclamationTriangle"));

var _ExclamationTriangleF = _interopRequireDefault(require("./ExclamationTriangleF"));

var _ExternalLink = _interopRequireDefault(require("./ExternalLink"));

var _Eye = _interopRequireDefault(require("./Eye"));

var _EyeAlt = _interopRequireDefault(require("./EyeAlt"));

var _EyeAltF = _interopRequireDefault(require("./EyeAltF"));

var _EyeSlash = _interopRequireDefault(require("./EyeSlash"));

var _Fallback = _interopRequireDefault(require("./Fallback"));

var _FinishLine = _interopRequireDefault(require("./FinishLine"));

var _Flag = _interopRequireDefault(require("./Flag"));

var _Floppy = _interopRequireDefault(require("./Floppy"));

var _Fog = _interopRequireDefault(require("./Fog"));

var _Folder = _interopRequireDefault(require("./Folder"));

var _Frown = _interopRequireDefault(require("./Frown"));

var _Funnel = _interopRequireDefault(require("./Funnel"));

var _Future = _interopRequireDefault(require("./Future"));

var _GiftF = _interopRequireDefault(require("./GiftF"));

var _Grid = _interopRequireDefault(require("./Grid"));

var _HandPaper = _interopRequireDefault(require("./HandPaper"));

var _HandSpock = _interopRequireDefault(require("./HandSpock"));

var _Handshake = _interopRequireDefault(require("./Handshake"));

var _Happy = _interopRequireDefault(require("./Happy"));

var _Headset = _interopRequireDefault(require("./Headset"));

var _History = _interopRequireDefault(require("./History"));

var _Home = _interopRequireDefault(require("./Home"));

var _Hourglass = _interopRequireDefault(require("./Hourglass"));

var _HourglassSlash = _interopRequireDefault(require("./HourglassSlash"));

var _Image = _interopRequireDefault(require("./Image"));

var _Info = _interopRequireDefault(require("./Info"));

var _InfoCircle = _interopRequireDefault(require("./InfoCircle"));

var _InfoCircleF = _interopRequireDefault(require("./InfoCircleF"));

var _Jpro = _interopRequireDefault(require("./Jpro"));

var _Key = _interopRequireDefault(require("./Key"));

var _Keypad = _interopRequireDefault(require("./Keypad"));

var _Kiosk = _interopRequireDefault(require("./Kiosk"));

var _Laptop = _interopRequireDefault(require("./Laptop"));

var _Lightbulb = _interopRequireDefault(require("./Lightbulb"));

var _LightbulbSlash = _interopRequireDefault(require("./LightbulbSlash"));

var _LineChart = _interopRequireDefault(require("./LineChart"));

var _LineChartBoard = _interopRequireDefault(require("./LineChartBoard"));

var _LineChartScreen = _interopRequireDefault(require("./LineChartScreen"));

var _Link = _interopRequireDefault(require("./Link"));

var _List = _interopRequireDefault(require("./List"));

var _Lock = _interopRequireDefault(require("./Lock"));

var _LockOpen = _interopRequireDefault(require("./LockOpen"));

var _Lot = _interopRequireDefault(require("./Lot"));

var _MachineLearning = _interopRequireDefault(require("./MachineLearning"));

var _MapPin = _interopRequireDefault(require("./MapPin"));

var _Microphone = _interopRequireDefault(require("./Microphone"));

var _MicrophoneSlash = _interopRequireDefault(require("./MicrophoneSlash"));

var _Minus = _interopRequireDefault(require("./Minus"));

var _MinusCircle = _interopRequireDefault(require("./MinusCircle"));

var _MinusCircleF = _interopRequireDefault(require("./MinusCircleF"));

var _Mobile = _interopRequireDefault(require("./Mobile"));

var _Money = _interopRequireDefault(require("./Money"));

var _MoneyCheck = _interopRequireDefault(require("./MoneyCheck"));

var _MugHot = _interopRequireDefault(require("./MugHot"));

var _Network = _interopRequireDefault(require("./Network"));

var _Newspaper = _interopRequireDefault(require("./Newspaper"));

var _Northstar = _interopRequireDefault(require("./Northstar"));

var _Note = _interopRequireDefault(require("./Note"));

var _OilCan = _interopRequireDefault(require("./OilCan"));

var _Paperclip = _interopRequireDefault(require("./Paperclip"));

var _PartlyCloudyDay = _interopRequireDefault(require("./PartlyCloudyDay"));

var _PartlyCloudyNight = _interopRequireDefault(require("./PartlyCloudyNight"));

var _Pause = _interopRequireDefault(require("./Pause"));

var _PauseCircle = _interopRequireDefault(require("./PauseCircle"));

var _Pencil = _interopRequireDefault(require("./Pencil"));

var _Phone = _interopRequireDefault(require("./Phone"));

var _PhoneArrow = _interopRequireDefault(require("./PhoneArrow"));

var _PhoneArrowIn = _interopRequireDefault(require("./PhoneArrowIn"));

var _PhoneArrowTimes = _interopRequireDefault(require("./PhoneArrowTimes"));

var _PhoneHangup = _interopRequireDefault(require("./PhoneHangup"));

var _PhoneTimes = _interopRequireDefault(require("./PhoneTimes"));

var _PieChart = _interopRequireDefault(require("./PieChart"));

var _PieChartBoard = _interopRequireDefault(require("./PieChartBoard"));

var _PieChartScreen = _interopRequireDefault(require("./PieChartScreen"));

var _Pin = _interopRequireDefault(require("./Pin"));

var _PizzaSlice = _interopRequireDefault(require("./PizzaSlice"));

var _Plug = _interopRequireDefault(require("./Plug"));

var _Plus = _interopRequireDefault(require("./Plus"));

var _PlusCircle = _interopRequireDefault(require("./PlusCircle"));

var _PlusCircleF = _interopRequireDefault(require("./PlusCircleF"));

var _Print = _interopRequireDefault(require("./Print"));

var _PuzzlePiece = _interopRequireDefault(require("./PuzzlePiece"));

var _Question = _interopRequireDefault(require("./Question"));

var _QuestionCircle = _interopRequireDefault(require("./QuestionCircle"));

var _QuestionCircleF = _interopRequireDefault(require("./QuestionCircleF"));

var _Rain = _interopRequireDefault(require("./Rain"));

var _Raindrop = _interopRequireDefault(require("./Raindrop"));

var _Receipt = _interopRequireDefault(require("./Receipt"));

var _Record = _interopRequireDefault(require("./Record"));

var _Redo = _interopRequireDefault(require("./Redo"));

var _Refresh = _interopRequireDefault(require("./Refresh"));

var _Reply = _interopRequireDefault(require("./Reply"));

var _Revert = _interopRequireDefault(require("./Revert"));

var _Road = _interopRequireDefault(require("./Road"));

var _RoadBlock = _interopRequireDefault(require("./RoadBlock"));

var _RoadExit = _interopRequireDefault(require("./RoadExit"));

var _Robot = _interopRequireDefault(require("./Robot"));

var _Rocket = _interopRequireDefault(require("./Rocket"));

var _ScanBarcode = _interopRequireDefault(require("./ScanBarcode"));

var _ScanQrcode = _interopRequireDefault(require("./ScanQrcode"));

var _Schedule = _interopRequireDefault(require("./Schedule"));

var _Search = _interopRequireDefault(require("./Search"));

var _Send = _interopRequireDefault(require("./Send"));

var _SendCheck = _interopRequireDefault(require("./SendCheck"));

var _SendTimes = _interopRequireDefault(require("./SendTimes"));

var _ServiceProvider = _interopRequireDefault(require("./ServiceProvider"));

var _Share = _interopRequireDefault(require("./Share"));

var _Shield = _interopRequireDefault(require("./Shield"));

var _ShoppingBag = _interopRequireDefault(require("./ShoppingBag"));

var _ShoppingBasket = _interopRequireDefault(require("./ShoppingBasket"));

var _Sleet = _interopRequireDefault(require("./Sleet"));

var _SlidersV = _interopRequireDefault(require("./SlidersV"));

var _Smile = _interopRequireDefault(require("./Smile"));

var _Snow = _interopRequireDefault(require("./Snow"));

var _Snowflake = _interopRequireDefault(require("./Snowflake"));

var _Sort = _interopRequireDefault(require("./Sort"));

var _SortAsc = _interopRequireDefault(require("./SortAsc"));

var _SortDesc = _interopRequireDefault(require("./SortDesc"));

var _Spaces = _interopRequireDefault(require("./Spaces"));

var _Star = _interopRequireDefault(require("./Star"));

var _StarF = _interopRequireDefault(require("./StarF"));

var _StickyNote = _interopRequireDefault(require("./StickyNote"));

var _StickyNotePlus = _interopRequireDefault(require("./StickyNotePlus"));

var _StickyNoteTimes = _interopRequireDefault(require("./StickyNoteTimes"));

var _Stopwatch = _interopRequireDefault(require("./Stopwatch"));

var _Tachometer = _interopRequireDefault(require("./Tachometer"));

var _Target = _interopRequireDefault(require("./Target"));

var _ThermometerFull = _interopRequireDefault(require("./ThermometerFull"));

var _ThumbsDown = _interopRequireDefault(require("./ThumbsDown"));

var _ThumbsUp = _interopRequireDefault(require("./ThumbsUp"));

var _Times = _interopRequireDefault(require("./Times"));

var _TimesCircle = _interopRequireDefault(require("./TimesCircle"));

var _TimesCircleF = _interopRequireDefault(require("./TimesCircleF"));

var _TimesPartialShield = _interopRequireDefault(require("./TimesPartialShield"));

var _TimesShield = _interopRequireDefault(require("./TimesShield"));

var _Tools = _interopRequireDefault(require("./Tools"));

var _TrafficLight = _interopRequireDefault(require("./TrafficLight"));

var _TrafficLightSlash = _interopRequireDefault(require("./TrafficLightSlash"));

var _Trash = _interopRequireDefault(require("./Trash"));

var _Truck = _interopRequireDefault(require("./Truck"));

var _Undo = _interopRequireDefault(require("./Undo"));

var _Unlink = _interopRequireDefault(require("./Unlink"));

var _Unpin = _interopRequireDefault(require("./Unpin"));

var _Upload = _interopRequireDefault(require("./Upload"));

var _User = _interopRequireDefault(require("./User"));

var _UserArrowRight = _interopRequireDefault(require("./UserArrowRight"));

var _UserBars = _interopRequireDefault(require("./UserBars"));

var _UserBusiness = _interopRequireDefault(require("./UserBusiness"));

var _UserCheck = _interopRequireDefault(require("./UserCheck"));

var _UserCode = _interopRequireDefault(require("./UserCode"));

var _UserKey = _interopRequireDefault(require("./UserKey"));

var _UserPlus = _interopRequireDefault(require("./UserPlus"));

var _UserTimes = _interopRequireDefault(require("./UserTimes"));

var _UserWrench = _interopRequireDefault(require("./UserWrench"));

var _Users = _interopRequireDefault(require("./Users"));

var _UsersGroup = _interopRequireDefault(require("./UsersGroup"));

var _Vert = _interopRequireDefault(require("./Vert"));

var _VideoCamera = _interopRequireDefault(require("./VideoCamera"));

var _VolumeUp = _interopRequireDefault(require("./VolumeUp"));

var _Wifi = _interopRequireDefault(require("./Wifi"));

var _Wind = _interopRequireDefault(require("./Wind"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = {
  AddressBook: _AddressBook.default,
  Angry: _Angry.default,
  Antenna: _Antenna.default,
  AntennaTimes: _AntennaTimes.default,
  Archive: _Archive.default,
  ArchiveArrowDown: _ArchiveArrowDown.default,
  ArchiveArrowUp: _ArchiveArrowUp.default,
  ArrowBottomLeftCorner: _ArrowBottomLeftCorner.default,
  ArrowBottomRightCorner: _ArrowBottomRightCorner.default,
  ArrowCompress: _ArrowCompress.default,
  ArrowDown: _ArrowDown.default,
  ArrowExpand: _ArrowExpand.default,
  ArrowLeft: _ArrowLeft.default,
  ArrowRight: _ArrowRight.default,
  ArrowTopLeftCorner: _ArrowTopLeftCorner.default,
  ArrowTopRightCorner: _ArrowTopRightCorner.default,
  ArrowUp: _ArrowUp.default,
  Asterisk: _Asterisk.default,
  Ban: _Ban.default,
  BarChart: _BarChart.default,
  BarChartBoard: _BarChartBoard.default,
  BarChartScreen: _BarChartScreen.default,
  Bars: _Bars.default,
  BaselineChart: _BaselineChart.default,
  Bell: _Bell.default,
  BookOpen: _BookOpen.default,
  Brain: _Brain.default,
  Briefcase: _Briefcase.default,
  BriefcasePlus: _BriefcasePlus.default,
  BriefcaseTimes: _BriefcaseTimes.default,
  Building: _Building.default,
  Bullhorn: _Bullhorn.default,
  BullhornTimes: _BullhornTimes.default,
  Calculator: _Calculator.default,
  Calendar: _Calendar.default,
  CalendarCheck: _CalendarCheck.default,
  CalendarExclamation: _CalendarExclamation.default,
  CalendarPlus: _CalendarPlus.default,
  CalendarTimes: _CalendarTimes.default,
  Camera: _Camera.default,
  CaretDown: _CaretDown.default,
  CaretUp: _CaretUp.default,
  CassetteTape: _CassetteTape.default,
  Check: _Check.default,
  CheckCircle: _CheckCircle.default,
  CheckCircleF: _CheckCircleF.default,
  CheckPartialShield: _CheckPartialShield.default,
  CheckShield: _CheckShield.default,
  Checklist: _Checklist.default,
  ChessCastle: _ChessCastle.default,
  ChessKnight: _ChessKnight.default,
  ChevronDoubleLeft: _ChevronDoubleLeft.default,
  ChevronDoubleRight: _ChevronDoubleRight.default,
  ChevronDown: _ChevronDown.default,
  ChevronLeft: _ChevronLeft.default,
  ChevronRight: _ChevronRight.default,
  ChevronUp: _ChevronUp.default,
  Circle: _Circle.default,
  CircleF: _CircleF.default,
  CircleHalfF: _CircleHalfF.default,
  Circuit: _Circuit.default,
  ClearDay: _ClearDay.default,
  ClearNight: _ClearNight.default,
  Clipboard: _Clipboard.default,
  ClipboardCheck: _ClipboardCheck.default,
  ClipboardExclamation: _ClipboardExclamation.default,
  ClipboardTimes: _ClipboardTimes.default,
  Clock: _Clock.default,
  Cloudy: _Cloudy.default,
  CoffeeHot: _CoffeeHot.default,
  Cog: _Cog.default,
  Comment: _Comment.default,
  CommentPlus: _CommentPlus.default,
  Copy: _Copy.default,
  CreditCard: _CreditCard.default,
  CreditCardCheck: _CreditCardCheck.default,
  CreditCardExclamation: _CreditCardExclamation.default,
  CreditCardPlus: _CreditCardPlus.default,
  CreditCardTimes: _CreditCardTimes.default,
  DeliveryCart: _DeliveryCart.default,
  Desktop: _Desktop.default,
  Diamond: _Diamond.default,
  Directions: _Directions.default,
  DoorEnter: _DoorEnter.default,
  DoorExit: _DoorExit.default,
  Download: _Download.default,
  EllipsisH: _EllipsisH.default,
  EllipsisV: _EllipsisV.default,
  Engine: _Engine.default,
  Envelope: _Envelope.default,
  EnvelopeCheck: _EnvelopeCheck.default,
  EnvelopeOpen: _EnvelopeOpen.default,
  EnvelopePlus: _EnvelopePlus.default,
  EnvelopeTimes: _EnvelopeTimes.default,
  Eraser: _Eraser.default,
  Exclamation: _Exclamation.default,
  ExclamationCircle: _ExclamationCircle.default,
  ExclamationCircleF: _ExclamationCircleF.default,
  ExclamationPartialShield: _ExclamationPartialShield.default,
  ExclamationShield: _ExclamationShield.default,
  ExclamationTriangle: _ExclamationTriangle.default,
  ExclamationTriangleF: _ExclamationTriangleF.default,
  ExternalLink: _ExternalLink.default,
  Eye: _Eye.default,
  EyeAlt: _EyeAlt.default,
  EyeAltF: _EyeAltF.default,
  EyeSlash: _EyeSlash.default,
  Fallback: _Fallback.default,
  FinishLine: _FinishLine.default,
  Flag: _Flag.default,
  Floppy: _Floppy.default,
  Fog: _Fog.default,
  Folder: _Folder.default,
  Frown: _Frown.default,
  Funnel: _Funnel.default,
  Future: _Future.default,
  GiftF: _GiftF.default,
  Grid: _Grid.default,
  HandPaper: _HandPaper.default,
  HandSpock: _HandSpock.default,
  Handshake: _Handshake.default,
  Happy: _Happy.default,
  Headset: _Headset.default,
  History: _History.default,
  Home: _Home.default,
  Hourglass: _Hourglass.default,
  HourglassSlash: _HourglassSlash.default,
  Image: _Image.default,
  Info: _Info.default,
  InfoCircle: _InfoCircle.default,
  InfoCircleF: _InfoCircleF.default,
  Jpro: _Jpro.default,
  Key: _Key.default,
  Keypad: _Keypad.default,
  Kiosk: _Kiosk.default,
  Laptop: _Laptop.default,
  Lightbulb: _Lightbulb.default,
  LightbulbSlash: _LightbulbSlash.default,
  LineChart: _LineChart.default,
  LineChartBoard: _LineChartBoard.default,
  LineChartScreen: _LineChartScreen.default,
  Link: _Link.default,
  List: _List.default,
  Lock: _Lock.default,
  LockOpen: _LockOpen.default,
  Lot: _Lot.default,
  MachineLearning: _MachineLearning.default,
  MapPin: _MapPin.default,
  Microphone: _Microphone.default,
  MicrophoneSlash: _MicrophoneSlash.default,
  Minus: _Minus.default,
  MinusCircle: _MinusCircle.default,
  MinusCircleF: _MinusCircleF.default,
  Mobile: _Mobile.default,
  Money: _Money.default,
  MoneyCheck: _MoneyCheck.default,
  MugHot: _MugHot.default,
  Network: _Network.default,
  Newspaper: _Newspaper.default,
  Northstar: _Northstar.default,
  Note: _Note.default,
  OilCan: _OilCan.default,
  Paperclip: _Paperclip.default,
  PartlyCloudyDay: _PartlyCloudyDay.default,
  PartlyCloudyNight: _PartlyCloudyNight.default,
  Pause: _Pause.default,
  PauseCircle: _PauseCircle.default,
  Pencil: _Pencil.default,
  Phone: _Phone.default,
  PhoneArrow: _PhoneArrow.default,
  PhoneArrowIn: _PhoneArrowIn.default,
  PhoneArrowTimes: _PhoneArrowTimes.default,
  PhoneHangup: _PhoneHangup.default,
  PhoneTimes: _PhoneTimes.default,
  PieChart: _PieChart.default,
  PieChartBoard: _PieChartBoard.default,
  PieChartScreen: _PieChartScreen.default,
  Pin: _Pin.default,
  PizzaSlice: _PizzaSlice.default,
  Plug: _Plug.default,
  Plus: _Plus.default,
  PlusCircle: _PlusCircle.default,
  PlusCircleF: _PlusCircleF.default,
  Print: _Print.default,
  PuzzlePiece: _PuzzlePiece.default,
  Question: _Question.default,
  QuestionCircle: _QuestionCircle.default,
  QuestionCircleF: _QuestionCircleF.default,
  Rain: _Rain.default,
  Raindrop: _Raindrop.default,
  Receipt: _Receipt.default,
  Record: _Record.default,
  Redo: _Redo.default,
  Refresh: _Refresh.default,
  Reply: _Reply.default,
  Revert: _Revert.default,
  Road: _Road.default,
  RoadBlock: _RoadBlock.default,
  RoadExit: _RoadExit.default,
  Robot: _Robot.default,
  Rocket: _Rocket.default,
  ScanBarcode: _ScanBarcode.default,
  ScanQrcode: _ScanQrcode.default,
  Schedule: _Schedule.default,
  Search: _Search.default,
  Send: _Send.default,
  SendCheck: _SendCheck.default,
  SendTimes: _SendTimes.default,
  ServiceProvider: _ServiceProvider.default,
  Share: _Share.default,
  Shield: _Shield.default,
  ShoppingBag: _ShoppingBag.default,
  ShoppingBasket: _ShoppingBasket.default,
  Sleet: _Sleet.default,
  SlidersV: _SlidersV.default,
  Smile: _Smile.default,
  Snow: _Snow.default,
  Snowflake: _Snowflake.default,
  Sort: _Sort.default,
  SortAsc: _SortAsc.default,
  SortDesc: _SortDesc.default,
  Spaces: _Spaces.default,
  Star: _Star.default,
  StarF: _StarF.default,
  StickyNote: _StickyNote.default,
  StickyNotePlus: _StickyNotePlus.default,
  StickyNoteTimes: _StickyNoteTimes.default,
  Stopwatch: _Stopwatch.default,
  Tachometer: _Tachometer.default,
  Target: _Target.default,
  ThermometerFull: _ThermometerFull.default,
  ThumbsDown: _ThumbsDown.default,
  ThumbsUp: _ThumbsUp.default,
  Times: _Times.default,
  TimesCircle: _TimesCircle.default,
  TimesCircleF: _TimesCircleF.default,
  TimesPartialShield: _TimesPartialShield.default,
  TimesShield: _TimesShield.default,
  Tools: _Tools.default,
  TrafficLight: _TrafficLight.default,
  TrafficLightSlash: _TrafficLightSlash.default,
  Trash: _Trash.default,
  Truck: _Truck.default,
  Undo: _Undo.default,
  Unlink: _Unlink.default,
  Unpin: _Unpin.default,
  Upload: _Upload.default,
  User: _User.default,
  UserArrowRight: _UserArrowRight.default,
  UserBars: _UserBars.default,
  UserBusiness: _UserBusiness.default,
  UserCheck: _UserCheck.default,
  UserCode: _UserCode.default,
  UserKey: _UserKey.default,
  UserPlus: _UserPlus.default,
  UserTimes: _UserTimes.default,
  UserWrench: _UserWrench.default,
  Users: _Users.default,
  UsersGroup: _UsersGroup.default,
  Vert: _Vert.default,
  VideoCamera: _VideoCamera.default,
  VolumeUp: _VolumeUp.default,
  Wifi: _Wifi.default,
  Wind: _Wind.default
};
exports.default = _default;
var names = ['address-book', 'angry', 'antenna', 'antenna-times', 'archive', 'archive-arrow-down', 'archive-arrow-up', 'arrow-bottom-left-corner', 'arrow-bottom-right-corner', 'arrow-compress', 'arrow-down', 'arrow-expand', 'arrow-left', 'arrow-right', 'arrow-top-left-corner', 'arrow-top-right-corner', 'arrow-up', 'asterisk', 'ban', 'bar-chart', 'bar-chart-board', 'bar-chart-screen', 'bars', 'baseline-chart', 'bell', 'book-open', 'brain', 'briefcase', 'briefcase-plus', 'briefcase-times', 'building', 'bullhorn', 'bullhorn-times', 'calculator', 'calendar', 'calendar-check', 'calendar-exclamation', 'calendar-plus', 'calendar-times', 'camera', 'caret-down', 'caret-up', 'cassette-tape', 'check', 'check-circle', 'check-circle-f', 'check-partial-shield', 'check-shield', 'checklist', 'chess-castle', 'chess-knight', 'chevron-double-left', 'chevron-double-right', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'circle', 'circle-f', 'circle-half-f', 'circuit', 'clear-day', 'clear-night', 'clipboard', 'clipboard-check', 'clipboard-exclamation', 'clipboard-times', 'clock', 'cloudy', 'coffee-hot', 'cog', 'comment', 'comment-plus', 'copy', 'credit-card', 'credit-card-check', 'credit-card-exclamation', 'credit-card-plus', 'credit-card-times', 'delivery-cart', 'desktop', 'diamond', 'directions', 'door-enter', 'door-exit', 'download', 'ellipsis-h', 'ellipsis-v', 'engine', 'envelope', 'envelope-check', 'envelope-open', 'envelope-plus', 'envelope-times', 'eraser', 'exclamation', 'exclamation-circle', 'exclamation-circle-f', 'exclamation-partial-shield', 'exclamation-shield', 'exclamation-triangle', 'exclamation-triangle-f', 'external-link', 'eye', 'eye-alt', 'eye-alt-f', 'eye-slash', 'fallback', 'finish-line', 'flag', 'floppy', 'fog', 'folder', 'frown', 'funnel', 'future', 'gift-f', 'grid', 'hand-paper', 'hand-spock', 'handshake', 'happy', 'headset', 'history', 'home', 'hourglass', 'hourglass-slash', 'image', 'info', 'info-circle', 'info-circle-f', 'jpro', 'key', 'keypad', 'kiosk', 'laptop', 'lightbulb', 'lightbulb-slash', 'line-chart', 'line-chart-board', 'line-chart-screen', 'link', 'list', 'lock', 'lock-open', 'lot', 'machine-learning', 'map-pin', 'microphone', 'microphone-slash', 'minus', 'minus-circle', 'minus-circle-f', 'mobile', 'money', 'money-check', 'mug-hot', 'network', 'newspaper', 'northstar', 'note', 'oil-can', 'paperclip', 'partly-cloudy-day', 'partly-cloudy-night', 'pause', 'pause-circle', 'pencil', 'phone', 'phone-arrow', 'phone-arrow-in', 'phone-arrow-times', 'phone-hangup', 'phone-times', 'pie-chart', 'pie-chart-board', 'pie-chart-screen', 'pin', 'pizza-slice', 'plug', 'plus', 'plus-circle', 'plus-circle-f', 'print', 'puzzle-piece', 'question', 'question-circle', 'question-circle-f', 'rain', 'raindrop', 'receipt', 'record', 'redo', 'refresh', 'reply', 'revert', 'road', 'road-block', 'road-exit', 'robot', 'rocket', 'scan-barcode', 'scan-qrcode', 'schedule', 'search', 'send', 'send-check', 'send-times', 'service-provider', 'share', 'shield', 'shopping-bag', 'shopping-basket', 'sleet', 'sliders-v', 'smile', 'snow', 'snowflake', 'sort', 'sort-asc', 'sort-desc', 'spaces', 'star', 'star-f', 'sticky-note', 'sticky-note-plus', 'sticky-note-times', 'stopwatch', 'tachometer', 'target', 'thermometer-full', 'thumbs-down', 'thumbs-up', 'times', 'times-circle', 'times-circle-f', 'times-partial-shield', 'times-shield', 'tools', 'traffic-light', 'traffic-light-slash', 'trash', 'truck', 'undo', 'unlink', 'unpin', 'upload', 'user', 'user-arrow-right', 'user-bars', 'user-business', 'user-check', 'user-code', 'user-key', 'user-plus', 'user-times', 'user-wrench', 'users', 'users-group', 'vert', 'video-camera', 'volume-up', 'wifi', 'wind'];
exports.names = names;
var categories = {
  "office": ["address-book", "archive-arrow-down", "archive-arrow-up", "archive", "calculator-32", "calculator", "calendar-32", "calendar-check-32", "calendar-check", "calendar-exclamation-32", "calendar-exclamation", "calendar-plus-32", "calendar-plus", "calendar-times-32", "calendar-times", "calendar", "checklist-32", "checklist", "clipboard-32", "clipboard-check-32", "clipboard-check", "clipboard-exclamation-32s", "clipboard-exclamation", "clipboard-times-32", "clipboard-times", "clipboards", "clock-32", "clock", "eraser", "floppy", "folder", "headset", "history-32", "history", "list-32", "list", "paperclip", "pencil-32", "pencil", "phone-arrow", "phone-hangup", "phone", "pin", "print-32", "print", "schedule-32", "schedule", "sticky-note-plus", "sticky-note-times", "sticky-note", "unpin"],
  "communication": ["address-book", "camera", "comment-32", "comment-plus-32", "comment-plus", "comment", "envelope-check", "envelope-open", "envelope-plus", "envelope-times", "envelope", "headset", "microphone-slash", "microphone", "newspaper", "note-32", "note", "phone-32", "phone-arrow-32", "phone-arrow-in-32", "phone-arrow-in", "phone-arrow-times-32", "phone-arrow", "phone-hangup-32", "phone-hangup", "phone-times", "phone", "reply", "send-check", "send-times", "send", "sticky-note-plus", "sticky-note-times", "sticky-note", "video-camera"],
  "people": ["angry", "frown", "happy", "smile", "user-32", "user-arrow-right-32", "user-arrow-right", "user-bars-32", "user-bars", "user-business-32", "user-business", "user-check-32", "user-check", "user-code-32", "user-code", "user-key-32", "user-key", "user-plus-32", "user-plus", "user-times-32", "user-times", "user-wrench-32", "user-wrench", "user", "users-32", "users-group-32", "users-group", "users"],
  "sign": ["angry", "asterix", "ban-32", "ban", "book-open-32", "book-open", "cassette-tape", "check-circle-32", "check-circle-f-32", "check-circle-f", "check-circle", "check-partial-shield", "check-shield-32", "check-shield", "check", "chess-castle", "chess-knight", "circle-f", "circle-half-f", "circle", "diamond", "directions-32", "directions", "exclamation-circle-32", "exclamation-circle-f-32", "exclamation-circle-f", "exclamation-circle", "exclamation-partial-shield", "exclamation-shield-32", "exclamation-shield", "exclamation-triangle-32", "exclamation-triangle-f-32", "exclamation-triangle-f", "exclamation-triangle", "exclamation", "flag", "frown", "gift-f", "hand-paper", "hand-spock", "handshake-32", "handshake", "happy", "image-32", "image", "info-circle-32", "info-circle-f-32", "info-circle-f", "info-circle", "info", "link", "map-pin-32", "map-pin", "minus-circle-32", "minus-circle-f-32", "minus-circle-f", "minus-circle", "minus", "northstar", "plus-circle-32", "plus-circle-f-32", "plus-circle-f", "plus-circle", "plus", "puzzle-piece", "question-circle-32", "question-circle-f-32", "question-circle-f", "question-circle", "question", "road-block", "shield-32", "shield", "shopping-bag", "shopping-basket", "smile", "spaces-32", "spaces", "star-f", "star", "target", "thumbs-down", "thumbs-up", "times-circle-32", "times-circle-f-32", "times-circle-f", "times-circle", "times-partial-shield", "times-shield-32", "times-shield", "times", "traffic-light-slash", "traffic-light", "unlink"],
  "technology": ["antenna-times", "antenna", "circuit", "desktop-32", "desktop", "jpro-32", "jpro", "laptop-32", "laptop", "machine-learning-32", "machine-learning", "mobile-32", "mobile", "network-32", "network", "plug", "robot-32", "robot"],
  "arrows": ["arrow-bottom-left-corner", "arrow-bottom-right-corner", "arrow-compress", "arrow-down", "arrow-expand", "arrow-left", "arrow-right", "arrow-top-left-corner", "arrow-top-right-corner", "arrow-up", "caret-down", "caret-up", "chevron-double-left", "chevron-double-right", "chevron-down", "chevron-left", "chevron-right", "chevron-up", "door-enter", "door-exit", "redo", "refresh", "reply", "revert", "sort-asc", "sort-desc", "sort", "undo", "vert"],
  "charts": ["bar-chart-32", "bar-chart-board-32", "bar-chart-board", "bar-chart-screen-32", "bar-chart-screen", "bar-chart", "baseline-chart-32", "baseline-chart", "line-chart-32", "line-chart-board-32", "line-chart-board", "line-chart-screen-32", "line-chart-screen", "line-chart", "pie-chart-32", "pie-chart-board-32", "pie-chart-board", "pie-chart-screen-32", "pie-chart-screen", "pie-chart"],
  "business": ["bar-chart-32", "bar-chart-board-32", "bar-chart-board", "bar-chart-screen-32", "bar-chart-screen", "bar-chart", "baseline-chart-32", "baseline-chart", "briefcase-32", "briefcase-plus-32", "briefcase-plus", "briefcase-times-32", "briefcase-times", "briefcase", "calculator-32", "calculator", "credit-card-32", "credit-card-check", "credit-card-exclamation", "credit-card-plus", "credit-card-times", "credit-card", "delivery-cart", "line-chart-32", "line-chart-board-32", "line-chart-board", "line-chart-screen-32", "line-chart-screen", "line-chart", "money-check", "money", "pie-chart-32", "pie-chart-board-32", "pie-chart-board", "pie-chart-screen-32", "pie-chart-screen", "pie-chart", "receipt", "service-provider-32", "service-provider"],
  "commerce": ["bar-chart-32", "bar-chart-board-32", "bar-chart-board", "bar-chart-screen-32", "bar-chart-screen", "bar-chart", "baseline-chart-32", "baseline-chart", "check-partial-shield", "check-shield-32", "check-shield", "credit-card-32", "credit-card-check", "credit-card-exclamation", "credit-card-plus", "credit-card-times", "credit-card", "delivery-cart", "line-chart-32", "line-chart-board-32", "line-chart-board", "line-chart-screen-32", "line-chart-screen", "line-chart", "money-check", "money", "pie-chart-32", "pie-chart-board-32", "pie-chart-board", "pie-chart-screen-32", "pie-chart-screen", "pie-chart", "receipt", "shield-32", "shield", "times-partial-shield", "times-shield-32", "times-shield"],
  "control": ["bars-32", "bars", "camera", "caret-down", "caret-up", "cassette-tape", "circle-half-f", "cog-32", "cog", "copy", "download", "ellipsis-h", "ellipsis-v", "eraser", "external-link", "eye-alt-f", "eye-alt", "eye-slash", "eye", "flag", "floppy", "funnel", "grid", "keypad", "lightbulb-32", "lightbulb-slash", "lightbulb", "link", "list-32", "list", "lock-32", "lock-open-32", "lock-open", "lock", "microphone-slash", "microphone", "minus-circle-32", "minus-circle-f-32", "minus-circle-f", "minus-circle", "minus", "network-32", "network", "pause-circle", "pause", "pencil-32", "pencil", "pin", "record", "redo", "refresh", "reply", "revert", "scan-barcode", "scan-qrcode", "search-32", "search", "send-check", "send-times", "send", "share-32", "share", "sliders-v-32", "sliders-v", "sort-asc", "sort-desc", "sort", "spaces-32", "spaces", "star-f", "star", "sticky-note-plus", "sticky-note-times", "sticky-note", "tachometer", "trash-32", "trash", "undo", "unlink", "unpin", "upload", "vert", "video-camera", "volume-up", "wifi"],
  "alert": ["bell-32", "bell", "bullhorn-32", "bullhorn-times", "bullhorn"],
  "anatomy": ["brain-32", "brain"],
  "places": ["building-32", "building", "door-enter", "door-exit", "home-32", "home", "kiosk-32", "kiosk", "lot-32", "lot", "service-provider-32", "service-provider"],
  "time": ["calendar-32", "calendar-check-32", "calendar-check", "calendar-exclamation-32", "calendar-exclamation", "calendar-plus-32", "calendar-plus", "calendar-times-32", "calendar-times", "calendar", "clock-32", "clock", "future-32", "future", "history-32", "history", "hourglass-32", "hourglass-slash", "hourglass", "schedule-32", "schedule", "stopwatch-32", "stopwatch", "tachometer-32"],
  "chess": ["chess-castle", "chess-knight"],
  "map": ["circle-f", "circle", "directions-32", "directions", "finish-line", "map-pin-32", "map-pin", "pin", "road-exit", "road", "traffic-light-slash", "traffic-light", "unpin"],
  "weather": ["clear-day", "clear-night", "cloudy", "fallback", "fog", "partly-cloudy-day", "partly-cloudy-night", "rain", "raindrop", "sleet", "snow", "snowflake", "thermometer-full", "wind"],
  "household": ["coffee-hot", "funnel", "mug-hot", "pizza-slice-32", "pizza-slice"],
  "equipment": ["engine", "oil-can", "rocket-32", "rocket", "tachometer", "thermometer-full", "tools", "truck-32", "truck"],
  "hands": ["hand-paper", "hand-spock", "handshake-32", "handshake", "thumbs-down", "thumbs-up"],
  "security": ["key", "lock-32", "lock-open-32", "lock-open", "lock"]
};
exports.categories = categories;